import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE || (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'http://127.0.0.1:8001' : '');

// Create axios instance with auth interceptor
const logoAPIClient = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

logoAPIClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Logo API endpoints
export const logoAPI = {
  // Get all active logos (no auth required)
  getActiveLogos: () => axios.get(`${API_BASE_URL}/api/site/logos/active_logos/`),
  
  // Get logo by type
  getLogoByType: (type: string) => logoAPIClient.get(`/site/logos/by_type/?type=${type}`),
  
  // Get all logos (admin)
  getAllLogos: () => logoAPIClient.get('/site/logos/'),
  
  // Create new logo (admin) — uses auth
  createLogo: (logoData: FormData) => logoAPIClient.post('/site/logos/', logoData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  
  // Update logo (admin) — uses auth
  updateLogo: (id: number, logoData: FormData) => logoAPIClient.patch(`/site/logos/${id}/`, logoData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  
  // Delete logo (admin)
  deleteLogo: (id: number) => logoAPIClient.delete(`/site/logos/${id}/`),
};

// Site configuration API (legacy — prefer api.ts siteConfigAPI)
export const siteConfigAPI = {
  getConfigs: () => logoAPIClient.get('/site/config/'),
  getConfig: (id: number) => logoAPIClient.get(`/site/config/${id}/`),
  createConfig: (data: any) => logoAPIClient.post('/site/config/', data),
  updateConfig: (id: number, data: any) => logoAPIClient.put(`/site/config/${id}/`, data),
  deleteConfig: (id: number) => logoAPIClient.delete(`/site/config/${id}/`),
};

// Logo types
export const LOGO_TYPES = {
  MAIN: 'main',
  HEADER: 'header',
  LOGIN: 'login',
  FAVICON: 'favicon',
};